import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const SoundOffFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function SoundOffFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M5.222 7c-2.76 0-5 2.24-5 5s2.24 5 5 5c.97 0 1.9.35 2.62 1l3.38 3h2V3h-2l-3.38 3c-.72.64-1.65 1-2.62 1ZM17.28 7.691l-2.121 2.122 2.192 2.192-2.192 2.192 2.121 2.121 2.192-2.192 2.185 2.185 2.121-2.121-2.185-2.185 2.185-2.185-2.121-2.122-2.185 2.185-2.192-2.192Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default SoundOffFilled;